import { useUser } from 'builder/hooks/useUser'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import * as Styles from './styles'
const TRANSLATION = 'builder.dashboard.header'

export const Header = () => {
  const user = useUser()
  const { i18n } = useI18n()
  const { isPhone, isTablet } = useMediaQueries()

  const title = user?.firstName
    ? i18n.t(`${TRANSLATION}.title`, { name: user?.firstName })
    : i18n.t(`${TRANSLATION}.fallback_title`)

  if (isPhone || isTablet) return null

  return (
    <Styles.Container>
      <Styles.Header>{title}</Styles.Header>
      <Styles.SubHeader>{i18n.t(`${TRANSLATION}.subtitle`)}</Styles.SubHeader>
    </Styles.Container>
  )
}
